export default {
  escape: 'Escape',
  enter: 'Enter',
  delete: 'Delete',
  f1: 'F1',
  a: 'a',
  s: 's',
  e: 'e',
  r: 'r',
};



// WEBPACK FOOTER //
// ./src/constants/keyBinds.js